export class BankMaster {
    public BankId: number;
    public BankName: string;
}
